import React, { useEffect, useMemo, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer";
import { get } from "../../helpers/api_helper";
import { GET_STOCK_HISTORY } from "../../helpers/url_helper";
import "toastr/build/toastr.min.css"; // Make sure this is imported for styling
import stockColumns from "components/Columns/StockHistoryColumns";

const StockHistory = () => {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    try {
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const role = Number(authUser?.user?.role);
      setIsAdmin(role === 1);
    } catch {
      setIsAdmin(false);
    }
  }, []);
  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Stock History", link: "#" },
  ];

  const [stocks, setstockes] = useState([]);
  const [pageIndex, setPageIndex] = useState(1); // Starts at 0
  const [pageSize, setPageSize] = useState(1000); // Default page size
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState([]);
  const [searchText, setSearchText] = useState("");

 const getStockHistoryList = async (page, size, sort = [], search = "") => {
    const sortKey = sort[0]?.id;
    const sortby = sort[0]?.desc ? "desc" : "asc";
    return await get(GET_STOCK_HISTORY, {
      params: {
        page,
        size,
        sortKey,
        sortby,
        search,
      },
    });
  }

const fetchStockHistory = async (
  page = 1,
  size = 50,
  sortBy = [],
  searchText
) => {
  try {
    const response = await getStockHistoryList(page, size, sortBy, searchText);
    const { data } = response;

    // Make sure data is an array
    setstockes(Array.isArray(data) ? data : []);
    setTotalPages(1); // Or update logic if you implement pagination
  } catch (error) {
    console.error("Failed to fetch stocks:", error);
    setstockes([]); // fallback on error
    setTotalPages(0);
  }
};

  const handleSearchChange = (text) => {
    setPageIndex(1);
    setSearchText(text);
  };

  useEffect(() => {
    fetchStockHistory(pageIndex, pageSize, sortBy, searchText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pageSize, sortBy, searchText]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const columns = useMemo(() => stockColumns(), [isAdmin]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Stock History"
            breadcrumbItems={breadcrumbItems}
          />
        </Container>

        <Card>
          <CardBody>
              {Array.isArray(stocks) && stocks.length > 0 ? (              
                <TableContainer
                columns={columns || []}
                data={stocks || []}
                isPagination={true}
                isSortable={true}
                isGlobalFilter={true}
                customPageSize={pageSize}
                isAddOptions={false}
                iscustomPageSize={false}
                isBordered={false}
                controlledPagination={{
                  pageIndex,
                  setPageIndex,
                  pageSize,
                  setPageSize,
                  totalPages,
                }}
                onSortChange={setSortBy}
                searchText={searchText}
                onSearchChange={handleSearchChange}
              />
            ) : (
                <p className="text-center mt-4">No stock history found.</p>
              )}

          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
};

export default StockHistory;
